import React, { useEffect, useState, useRef } from "react";
import { article } from "@Api";
import { useSetState } from "ahooks";
import TabBar from "./RelatedInfoCom/tabBar";
import Article from "./RelatedInfoCom/article";
import { Button, ConfigProvider, Pagination, Spin } from "antd";
import zhTW from "antd/es/locale/zh_TW";
import cx from "classnames";

import styles from "./RelatedInfo.module.less";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { fetchV3Articles } = article;

export interface IProps {
  title?: string;
  limit?: number;
}

const RelatedInfo: React.FC<IProps> = ({ title = "相關資訊", limit = 6 }) => {
  const [dataSource, setDataSource] = useSetState({
    list: [],
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({});
  const currentPage = useRef<number>(1);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const res: any = await fetchV3Articles({ kindId: window.kindId, limit: limit, ...params });
      setDataSource(res.data);
      setLoading(false);
    } catch (error) {}
  };

  const handleTabClick = (data) => {
    fetch(data);
    setQuery(data);
  };

  const pageChange = (page) => {
    fetch({ page: page, ...query });
  };

  const handleChangePagination = async (page, pageSize): Promise<any> => {
    currentPage.current = page;
    pageChange(page);
  };

  const itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <Button>
          <a>
            <LeftOutlined />
            上一頁
          </a>
        </Button>
      );
    }
    if (type === "next") {
      return (
        <Button>
          <a>
            下一頁
            <RightOutlined />
          </a>
        </Button>
      );
    }
    if (type === "page") {
      return <a>{current}</a>;
    }
    return originalElement;
  };

  useEffect(() => {
    fetch({});
  }, []);

  return (
    <div id='RelatedInfo' className={styles["summary-info"]}>
      {title && <h3 className={styles["title"]}>{title}</h3>}
      <TabBar kindId={window.kindId} handleClick={handleTabClick} />
      <Spin spinning={loading}>
        <div className={styles["field"]} style={{ marginTop: "40px" }}>
          <div className={styles["articles-field"]}>
            {Array.isArray(dataSource.list) &&
              dataSource.list.length > 0 &&
              dataSource.list.map((item, index) => <Article key={index} dataSource={item} />)}
          </div>
        </div>
      </Spin>
      <ConfigProvider locale={zhTW}>
        <Pagination
          defaultCurrent={1}
          total={dataSource.total}
          itemRender={itemRender}
          pageSize={20}
          showQuickJumper={{
            goButton: <Button className={cx(styles["pagination-btn"])}>確定</Button>,
          }}
          className={cx({
            [styles["theme-color-green"]]: window.SEARCH_TYPE === "ev",
          })}
          showSizeChanger={false}
          current={currentPage.current}
          hideOnSinglePage
          onChange={handleChangePagination}
        />
      </ConfigProvider>
    </div>
  );
};

export default RelatedInfo;
